import { render, staticRenderFns } from "./HtmlEditorTiptapToolbarColor.vue?vue&type=template&id=d64cd072&"
import script from "./HtmlEditorTiptapToolbarColor.vue?vue&type=script&lang=js&"
export * from "./HtmlEditorTiptapToolbarColor.vue?vue&type=script&lang=js&"
import style0 from "./HtmlEditorTiptapToolbarColor.vue?vue&type=style&index=0&id=d64cd072&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports